'use strict';

/**
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');

var template = require('modules/base/templates/layout/restriction-sets-modal.hbs');

var RestrictionModalView = ColidoLayoutView.extend({
    template: template,

    ui: {
        actionClose: '[data-action="close"]',
        deleteSet: '[data-action="delete-set"]',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
        'click @ui.deleteSet': 'actionDeleteSet',
    },

    actionDeleteSet: function (event) {
        if (!window.confirm(App.t('collection::set:confirm-delete-set', {name: this.getOption('model').get('name')}))) {
            return;
        }

        App.radio('collection:set').execute('delete', this.getOption('model'));
        this.trigger('close:modal');
    },

    actionClose: function (event) {
        this.trigger('close:modal');
    },
});

module.exports = RestrictionModalView;